export function formatMinutes(totalMinutes: number): string {
  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  if (hrs === 0) {
    return `${mins} ${mins === 1 ? "min" : "mins"}`;
  } else if (mins === 0) {
    return `${hrs} ${hrs === 1 ? "hr" : "hrs"}`;
  } else {
    return `${hrs} ${hrs === 1 ? "hr" : "hrs"} ${mins} ${mins === 1 ? "min" : "mins"}`;
  }
}
